document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu]');
  const drawer = document.querySelector('#MobileMenu');
  if (menuButton && drawer) {
    menuButton.addEventListener('click', () => {
      const isOpen = !drawer.hasAttribute('hidden');
      if (isOpen) drawer.setAttribute('hidden', ''); else drawer.removeAttribute('hidden');
      menuButton.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-cart-quantity-minus], [data-cart-quantity-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      const subtract = button.hasAttribute('data-cart-quantity-minus');
      input.value = Math.max(subtract ? current - 1 : current + 1, 0);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const setProductMedia = (source, mediaId = '') => {
    const mainImage = document.querySelector('.product-main-media img');
    if (mainImage && source) {
      mainImage.src = source;
      mainImage.srcset = source;
    }
    document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const isActive = Boolean(mediaId) && thumb.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
    });
  };

  document.querySelectorAll('[data-gallery-thumb]').forEach(button => {
    button.addEventListener('click', () => setProductMedia(button.dataset.src, button.dataset.mediaId));
  });

  document.querySelectorAll('[data-variant-selector]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const matchingThumbnail = option.dataset.mediaId
        ? document.querySelector(`[data-gallery-thumb][data-media-id="${option.dataset.mediaId}"]`)
        : null;
      setProductMedia(matchingThumbnail?.dataset.src || option.dataset.imageSrc, option.dataset.mediaId);
    });
  });

  const codReturnCta = document.querySelector('[data-cod-return-cta]');
  if (codReturnCta) {
    const getCodForm = () => document.querySelector('#leadform-embedded-container .leadform-container, #leadform-submit-form');
    let animationFrame;
    const updateCodReturnCta = () => {
      const codForm = getCodForm();
      const formHasPassedCompletely = codForm && codForm.getBoundingClientRect().bottom < 0;
      codReturnCta.hidden = !formHasPassedCompletely;
    };
    const queueCodReturnCtaUpdate = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateCodReturnCta);
    };
    codReturnCta.addEventListener('click', () => {
      const codForm = getCodForm();
      if (!codForm) return;
      codForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => codForm.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true }), 550);
    });
    window.addEventListener('scroll', queueCodReturnCtaUpdate, { passive: true });
    window.addEventListener('resize', queueCodReturnCtaUpdate);
    new MutationObserver(queueCodReturnCtaUpdate).observe(document.body, { childList: true, subtree: true });
    queueCodReturnCtaUpdate();
  }

  document.querySelectorAll('[data-sort-by]').forEach(select => {
    select.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  });

  const policyTarget = window.location.hash ? document.querySelector(window.location.hash) : null;
  if (policyTarget && policyTarget.matches('details')) {
    policyTarget.open = true;
    window.setTimeout(() => policyTarget.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  }
});
